import { getCatalogSectionsForTab } from '../../data/productsCatalogData'
import ProductsCatalogSection from '../products/ProductsCatalogSection'

function ProductsCatalogSections({ activeCategory }) {
  const sections = getCatalogSectionsForTab(activeCategory)

  return (
    <div className="products-catalog-wrap" id="products-catalog">
      {sections.length === 0 ? (
        <div className="container corp-container">
          <p className="products-catalog-empty">No products in this category yet.</p>
        </div>
      ) : (
        sections.map((section) => (
          <ProductsCatalogSection key={section.id} section={section} />
        ))
      )}
    </div>
  )
}

export default ProductsCatalogSections
